/** Private header populated only after the server verifies BRC-104. */
export const VERIFIED_WALLET_IDENTITY_HEADER =
	"x-sigma-verified-wallet-identity";
export const WALLET_SIGNIN_PLUGIN_PATH = "/sign-in/wallet";
export const WALLET_SIGNIN_REQUEST_PATH = `/api/auth${WALLET_SIGNIN_PLUGIN_PATH}`;
